import React from "react"
import { Box } from "@mui/material"

export default function CenterCrosshair() {

    const tickStyle = {
        position: "absolute",
        background: "black",
        top: "50%",
        left: "50%",
      };
    
      const tickHor = {
        ...tickStyle,
        height: "2px",
        width: "4px",
        mt: "-1px"
      };
    
      const tickVert = {
        ...tickStyle,
        width: "2px",
        height: "4px",
        ml: "-1px"
      };

    return (
        <Box
            m={0}
            p={0}
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                ml: "-5px",
                mt: "-5px",
                width: 10,
                height: 10,
                border: 1,
                borderColor: "black",
                borderRadius: "50%",
                zIndex: 1,
            }}
        >
        <Box
            sx={{
                ...tickHor,
                marginLeft: "-9px"
            }}
        />
        <Box
            sx={{
                ...tickHor,
                marginLeft: "5px"
            }}
        />
        <Box
            sx={{
                ...tickVert,
                marginTop: "-9px"
            }}
        />
        <Box
            sx={{
                ...tickVert,
                marginTop: "5px"
            }}
        />
        </Box>
    )
}